import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  tokenId?: string;
  userId?: string;
}

const initialState: AuthState = {
  tokenId: undefined,
  userId: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setTokenId: (state, action: PayloadAction<string>) => {
      state.tokenId = action.payload;
    },
  },
});

export const { setUserId, setTokenId } = authSlice.actions;

export default authSlice.reducer;
